// API Configuration - Optimized for Hostinger hosting
export const API_CONFIG = {
  // Laravel backend base URL - Update this for Hostinger deployment
  BASE_URL: process.env.REACT_APP_API_URL || "https://rdandcompany.in/backend/public",

  // Request timeout settings for better performance
  TIMEOUT: 30000, // 30 seconds

  // Retry configuration
  MAX_RETRIES: 3,
  RETRY_DELAY: 1000, // 1 second

  // Cache settings
  CACHE_ENABLED: true,
  CACHE_DURATION: 300000, // 5 minutes

  // API Endpoints (Laravel)
  ENDPOINTS: {
    LOGIN: "/api/login",
    LOGOUT: "/api/logout",
    VERIFY: "/api/verify",
    USERS: "/api/admin/users",
    ORDERS: "/api/orders",
    TASKS: "/api/tasks",
    TASK_USERS: "/api/tasks/users",
    ATTENDANCE_STATUS: "/api/attendance/status",
    ATTENDANCE_START: "/api/attendance/start",
    ATTENDANCE_END: "/api/attendance/end",
    ATTENDANCE_HISTORY: "/api/attendance/history",
    ATTENDANCE_ALL: "/api/attendance/all",
    ATTENDANCE_OFFICE_LOCATION: "/api/attendance/office-location",
    SALES_REPORTS: "/api/sales/reports",
    SALES_UPLOAD_PHOTO: "/api/sales/upload-photo",
    LEDGERS: "/api/ledgers",
    LEDGER_UPLOAD: "/api/ledgers/{id}/upload",
    LEDGER_DOWNLOAD: "/api/ledgers/{id}/download",
    CLIENT_PAYMENTS: "/api/client-payments",
    CLIENT_PAYMENT_STATUS: "/api/client-payments/{id}/status",
    CLIENT_PAYMENT_SALES_PERSONS: "/api/client-payments/sales-persons",
    WARRANTY: "/api/warranty",
    WARRANTY_STATISTICS: "/api/warranty/statistics",

    // Performance monitoring endpoints
    PERFORMANCE_METRICS: "/api/performance/metrics",
    PERFORMANCE_DB_HEALTH: "/api/performance/database-health",
    PERFORMANCE_OPTIMIZE_DB: "/api/performance/optimize-database",
    PERFORMANCE_CLEAR_CACHE: "/api/performance/clear-cache",
    PERFORMANCE_WARM_UP_CACHE: "/api/performance/warm-up-cache",
  },
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};
